<template>
  <footer class="base-footer">
    <div class="footer-wrapper">
      <div class="footer-wrapper--table">
        <nav class="footer-links">
          <span class="footer-links-item">
            <h5 class="text-subtitle text-bold text-white-monochrome">
              {{ $t("footer.f_comm") }}
            </h5>
            <div class="flexbox community">
              <a
                href="mailto:hi@rwa-estate.com"
                class="text-body-1 mobile-font--b5 email-desktop"
                >hi@rwa-estate.com</a
              >
              <div class="email-mobile">
                <a
                href="mailto:hi@rwa-estate.com"
                class="text-body-1 mobile-font--b5"
                >hi@rwa-estate.com</a
              >
              </div>
              <a
                class="text-body-1 mobile-font--b5 add-unit-link"
                href="https://t.me/rwasupport"
                target="_blank"
                rel="noopener noreferrer"
                @click.prevent="addUnit"
                >{{ $t("header.h_add") }}</a
              >
            </div>
          </span>
          <span class="footer-links-item">
            <h5 class="text-subtitle text-bold text-white-monochrome">
              {{ $t("footer.f_legal.title") }}
            </h5>
            <span
              class="text-body-1 mobile-font--b5"
              @click="handleLink('privacy-policy')"
              >{{ $t("footer.f_legal.privacy") }}
            </span>
            <span
              class="text-body-1 mobile-font--b5"
              @click="handleLink('terms')"
              >{{ $t("footer.f_legal.terms") }}
            </span>
            <span
              class="text-body-1 mobile-font--b5"
              @click="handleLink('cookies-policy')"
              >{{ $t("footer.f_legal.cookies") }}
            </span>
            <p class="text-body-1 mobile-font--b7 footer-copyright">
              {{ $t("footer.f_copyright", { year: currentYear }) }}
            </p>
          </span>
        </nav>
      </div>

      <div class="footer-wrapper--logo">
        <img src="~/assets/icons/Logo_light.svg" alt="" >
      </div>

      <p class="footer-disclaimer text-body-2 mobile-font--b6">
        {{ $t("footer.f_disclaimer") }}
      </p>
    </div>
  </footer>
</template>

<script setup lang="ts">
const localePath = useLocalePath()
const { locale } = useI18n()
const currentYear = new Date().getFullYear()

const handleLink = (link: string) => {
  const route = localePath(`/${link}`)
  window.open(route, "_blank")
}

const addUnit = () => {
  window.open("https://t.me/rwasupport", "_blank")
}
</script>

<style scoped lang="scss">
.base-footer {
  // height: 460px;
  width: 100%;
  max-width: 100dvw;
  overflow: hidden;
  background-color: var(--black-monochrome);
  border-top-right-radius: 40px;
  border-top-left-radius: 40px;
  .footer-wrapper {
    position: relative;
    bottom: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 72px 24px 0;
    overflow: hidden;
    display: grid;
    align-items: center;
    justify-content: center;
    grid-template-columns: 1fr;
    max-width: 1440px;
    margin: auto;
    box-sizing: border-box;
    row-gap: 31px;

    // @media (max-width: 2599px) {
    //   max-width: 1440px;
    //   margin: auto;
    // }

    &--table {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: flex-start;
      row-gap: 32px;
      column-gap: 50px;
      .footer {
        &-links {
          display: contents;

          &-item {
            display: grid;
            grid-template-columns: 1fr;
            align-self: start;
            row-gap: 15px;
            width: 100%;
            .flexbox {
              // max-width: 150px;
              display: flex;
              flex-wrap: wrap;
              gap: 24px;
            }
            .community {
              flex-direction: column;
              gap: 17px;
            }
            a,
            span {
              text-decoration: none;
              color: var(--gray-monochrome);
              cursor: pointer;
            }
            .add-unit-link {
              color: var(--white-monochrome);
              text-decoration: underline;
              text-underline-offset: 3px;
              &:hover {
                opacity: 0.8;
              }
            }
            .footer-copyright {
              margin: 0;
              padding-top: 16px;
              color: var(--gray-monochrome);
              cursor: default;
            }
          }
        }
        .email-mobile{
          display: none;
        }
      }
    }
    &--info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      grid-column: span 3;
      align-self: flex-end;
      a {
        color: var(--gray-monochrome);
        text-decoration: none;
      }
    }
    &--logo {
      position: relative;
      align-self: flex-end;
      width: 100%;
      margin-top: 8px;
      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }
  }
  .footer-disclaimer {
    width: 100%;
    margin: 0;
    padding: 24px 0 32px;
    color: var(--gray-monochrome);
    line-height: 1.5;
    max-width: 1440px;
    border-top: 1px solid var(--gray-monochrome-20);
    padding-top: 24px;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .email-mobile {
    display: none;
  }
}

@media (max-width: 44rem) {
  .base-footer {
    height: auto;
    width: 100%;
    border-top-right-radius: 0;
    border-top-left-radius: 0;

    .footer-disclaimer {
      padding: 16px 24px 24px;
    }

    .footer-wrapper {
      max-width: 100%;
      padding: 40px 0 40px;
      gap: 24px;

      &--table {
        grid-template-columns: 1fr;
        padding: 0 24px;

        .footer {
          &-links {
            display: grid;
            grid-template-columns: 1fr;
            width: fit-content;
            margin-top: 8px;
            gap: 32px;
            order: 1;
            &-item {
              row-gap: 12px;

              .flexbox {
                max-width: unset;
              }

              .footer-copyright {
                margin-top: 12px;
                padding-top: 0;
              }
            }
          }

        }
      }

      &--logo {
        height: auto;
        grid-row-end: 1;
        padding: 0 24px 16px;
        margin: 0;
        border-bottom: 1px solid var(--gray-monochrome-20);

        img {
          position: relative;
          bottom: unset;
          left: unset;
          width: 203px;
          max-height: unset;
        }
      }
    }
    .email-desktop {
      display: none;
    }
    .email-mobile {
      display: block;
      width: 100%;
      a {
        color: var(--gray-monochrome);
        text-decoration: none;
      }
    }
  }
  @include mobile-fonts;
}
</style>
